import _Empty from "@arco-design/web-react/es/Empty";
import _Link from "@arco-design/web-react/es/Link";
import _Typography from "@arco-design/web-react/es/Typography";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import _Message from "@arco-design/web-react/es/Message";
import _Modal from "@arco-design/web-react/es/Modal";
import _Button from "@arco-design/web-react/es/Button";
import _Tabs from "@arco-design/web-react/es/Tabs";
import _Spin from "@arco-design/web-react/es/Spin";
import _useRequest from "@byted/hooks/es/useRequest";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import { listDiffTokens } from '@api/theme';
import useResetToken from '../resetToken/useResetToken';
import { listDiffStyles } from '@src/utils/api/style';
import DiffTokenTable from './diffTokenTable';
import { useSelector } from 'react-redux';
import useResetStyle from '@src/pages/common/lessEditor/useResetStyle';
import useLocale from '@src/hooks/useLocale';
import style from './style.less';
export var useDiffTokens = function useDiffTokens(params) {
  var themeId = params.themeId;
  var _a = _useRequest(function () {
      return Promise.all([listDiffStyles({
        themeId: themeId,
        isPublish: false
      }), listDiffTokens({
        themeId: themeId
      })]).then(function (result) {
        var userInfos = __assign(__assign({}, result[0].userInfos), result[1].userInfos);
        return __spreadArray(__spreadArray([], __read(result[0].list), false), __read(result[1].list), false).map(function (item) {
          return __assign(__assign({}, item), {
            userInfo: userInfos[item.operator]
          });
        });
      });
    }, {
      auto: true,
      refreshDeps: [themeId, params.refresh]
    }),
    loading = _a.loading,
    data = _a.data,
    run = _a.run;
  return {
    loading: loading,
    run: run,
    data: data
  };
};
var TabsText = {
  Base: '基础样式',
  General: '通用',
  Navigation: '导航',
  DataDisplay: '数据展示',
  DataEntry: '数据输入',
  Feedback: '反馈',
  Others: '其他'
};
var DiffTokens = function DiffTokens(props) {
  var _a = useLocale(),
    lang = _a.lang,
    t = _a.t;
  var isZh = lang === 'zh-CN';
  var _b = useDiffTokens({
      themeId: props.themeId,
      refresh: props.refresh
    }),
    loading = _b.loading,
    data = _b.data,
    run = _b.run;
  var _c = __read(useState(), 2),
    activeTab = _c[0],
    setActiveTab = _c[1];
  var _d = __read(useState({}), 2),
    selectedRowKeys = _d[0],
    setSelectedRowKeys = _d[1];
  var docs = useSelector(function (state) {
    return state.theme.docs;
  });
  var _e = useResetToken({}),
    resetLoading = _e.loading,
    resetToken = _e.run,
    tokenQuery = _e.query;
  var _f = useResetStyle(),
    resetStyleLoading = _f.loading,
    resetStyle = _f.run,
    styleQuery = _f.query;
  var tabs = useMemo(function () {
    return (data || []).reduce(function (result, item) {
      var _a;
      var type = ((_a = docs[item.component]) === null || _a === void 0 ? void 0 : _a.category) || 'Others';
      if (type) {
        result[type] = result[type] || [];
        result[type].push(item);
        result[type].sort(function (a, b) {
          return a.component > b.component ? 1 : -1;
        });
      }
      return Object.keys(TabsText).reduce(function (total, key) {
        if (result[key]) {
          total[key] = result[key];
        }
        return total;
      }, {});
    }, {});
  }, [data]);
  useEffect(function () {
    var onLoad = props.onLoad;
    onLoad && onLoad(Array.from(new Set(data === null || data === void 0 ? void 0 : data.map(function (item) {
      return item.component;
    }))));
    setActiveTab(Object.keys(tabs)[0]);
  }, [tabs]);
  if (loading && !Object.keys(tabs).length) {
    return /*#__PURE__*/React.createElement(_Spin, {
      className: "align-loading"
    });
  }
  var selectedKeys = Array.prototype.concat.apply([], Object.values(selectedRowKeys));
  return Object.keys(tabs).length ? /*#__PURE__*/React.createElement(_Spin, {
    block: true,
    loading: loading
  }, /*#__PURE__*/React.createElement(_Tabs, {
    className: style['theme-diff-token-tabs'],
    type: "text",
    activeTab: activeTab || Object.keys(tabs)[0],
    onChange: setActiveTab,
    extra: props.rowSelections !== false && /*#__PURE__*/React.createElement(_Button, {
      status: "danger",
      shape: "round",
      disabled: !selectedKeys.length,
      onClick: function onClick() {
        return __awaiter(void 0, void 0, void 0, function () {
          var list, keys;
          var _a;
          return __generator(this, function (_b) {
            list = (data === null || data === void 0 ? void 0 : data.filter(function (x) {
              return selectedKeys.find(function (item) {
                return item === x._id;
              });
            })) || [];
            keys = list.filter(function (item) {
              return item.key;
            }).map(function (item) {
              return item.key;
            });
            _Modal.confirm({
              title: (_a = t['edit.history.reset.batch.modal.title']) === null || _a === void 0 ? void 0 : _a.replace('{total}', keys.length),
              content: /*#__PURE__*/React.createElement("div", {
                style: {
                  textAlign: 'center'
                }
              }, t['edit.history.reset.content']),
              onOk: function onOk() {
                return __awaiter(void 0, void 0, void 0, function () {
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4, resetToken({
                          themeId: props.themeId,
                          keys: keys
                        })];
                      case 1:
                        _a.sent();
                        _Message.success(t['edit.history.reset.success']);
                        run();
                        return [2];
                    }
                  });
                });
              },
              okText: t['edit.history.reset.confirm'],
              okButtonProps: {
                status: 'danger'
              }
            });
            return [2];
          });
        });
      }
    }, t['edit.history.reset.btn'], " ", selectedKeys.length > 0 && selectedKeys.length)
  }, Object.keys(tabs).map(function (key) {
    var _a;
    return /*#__PURE__*/React.createElement(_Tabs.TabPane, {
      key: key,
      title: (isZh ? TabsText[key] : key) + " " + ((_a = tabs[key]) === null || _a === void 0 ? void 0 : _a.length)
    }, /*#__PURE__*/React.createElement(DiffTokenTable, {
      tableProps: __assign(__assign({}, props.rowSelections !== false ? {
        rowSelection: {
          checkboxProps: function checkboxProps(record) {
            return {
              disabled: !record.key
            };
          },
          checkCrossPage: true,
          type: 'checkbox',
          onChange: function onChange(_, rows) {
            var _a;
            setSelectedRowKeys(__assign(__assign({}, selectedRowKeys), (_a = {}, _a[key] = rows.map(function (item) {
              return item._id;
            }), _a)));
          }
        }
      } : {}), props.tableProps),
      data: tabs[key],
      operationColumns: [{
        title: isZh ? '操作' : 'Aciton',
        width: 100,
        fixed: 'right',
        render: function render(_, record) {
          var _a;
          return /*#__PURE__*/React.createElement(_Popconfirm, {
            getPopupContainer: function getPopupContainer() {
              return document.body;
            },
            title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography.Text, {
              bold: true
            }, t['edit.history.reset.title']), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
              style: {
                maxWidth: 200
              }
            }, t['edit.history.reset.content'])),
            okText: t['edit.history.reset.confirm'],
            okButtonProps: {
              status: 'danger'
            },
            onOk: function onOk() {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      if (!record.code) return [3, 2];
                      return [4, resetStyle({
                        themeId: props['themeId'],
                        component: record.component
                      })];
                    case 1:
                      _a.sent();
                      return [3, 4];
                    case 2:
                      return [4, resetToken({
                        themeId: props['themeId'],
                        keys: [record.key]
                      })];
                    case 3:
                      _a.sent();
                      _a.label = 4;
                    case 4:
                      _Message.success(t['edit.history.reset.success']);
                      run();
                      return [2];
                  }
                });
              });
            }
          }, /*#__PURE__*/React.createElement(_Link, {
            disabled: resetLoading || resetStyleLoading,
            hoverable: false,
            status: "error"
          }, resetLoading && (tokenQuery === null || tokenQuery === void 0 ? void 0 : tokenQuery.keys) && ((_a = tokenQuery.keys) === null || _a === void 0 ? void 0 : _a.indexOf(record.key)) > -1 || resetStyleLoading && (styleQuery === null || styleQuery === void 0 ? void 0 : styleQuery.component) === record.component ? t['edit.history.reset.undoing'] : t['edit.history.reset.undo']));
        }
      }]
    }));
  }))) : /*#__PURE__*/React.createElement(_Empty, {
    style: {
      marginTop: 50
    }
  });
};
export default DiffTokens;